// The default export will be the theme used by the styleguide
import { ThemeConstellation } from '@zillow/constellation';
import { setConfiguration } from 'react-grid-system';
import media from './tokens/media';

const ThemeComet = {
  comet: {
    // DEPRECATED: Please use media from constellatoin
    media,
  },
};

/*
breakpoints: {
    xs: 0,
    sm: 321,
    md: 481,
    lg: 769,
    xl: 1024,
    xxl: 1281,
},
*/
// We remove the first index from the breakpoints array because
// react-grid-system already has a default xs value === 0
const [, ...breakpoints] = Object.values(ThemeConstellation.ns().breakpoints);

setConfiguration({
  breakpoints,
  gutterWidth: 0,
});

export default {
  ...ThemeComet,
  ...ThemeConstellation,
};
